import es from './es';

/**
 * Obtiene un texto en español por clave (p. ej. 'exception.wrong_coords').
 * Las etiquetas de la interfaz van fijas en las plantillas HTML.
 *
 * @param {string} keyPath
 * @return {string}
 * @public
 * @api
 */
export const getValue = (keyPath) => {
  const value = keyPath.split('.').reduce((prev, current) => prev[current], es);
  return value !== undefined && value !== null ? value : keyPath;
};

/**
 * @deprecated Solo español; mantiene compatibilidad con la API del plugin.
 */
export const addTranslation = () => {};

/**
 * @deprecated Solo español; mantiene compatibilidad con la API del plugin.
 */
export const getTranslation = () => es;
